import { render, staticRenderFns } from "./ViewControlls.vue?vue&type=template&id=16cf9d52&"
import script from "./ViewControlls.vue?vue&type=script&lang=js&"
export * from "./ViewControlls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports